<template>
  <div
    v-if="
      usuarioInfo.vendedor &&
      showCardCustomer &&
      !dadosPedido.carrinhoNaoPodeSerCompartilhado
    "
    class="flex flex-col justify-center items-center pr-8 pl-8 pt-4 pb-4 w-full"
  >
    <Transition name="slide-fade" mode="out-in" appear>
      <div
        v-if="showCardCustomer"
        key="card-help"
        class="flex flex-row justify-between items-center w-full"
      >
        <div>
          <p class="p-0 m-0 text-gray font-bold">
            Deseja enviar o carrinho para o cliente?
          </p>
          <p class="p-0 m-0 text-gray font-bold text-lg">
            Envie o carrinho para o cliente.
          </p>
        </div>
        <button
          class="btn btn-sm btn-primary"
          style="width: 20%; justify-content: center; padding: 5px 0px"
          @click="showCustomerModal = true"
        >
          Enviar carrinho
        </button>
      </div>
    </Transition>
    <modal-cliente-info
      v-if="showCustomerModal"
      :sellers="sellers"
      :is-loading="isLoading"
      :show-allow-finish-order="
        dadosPedido.permiteAlterarPermissaoFinalizarPedido
      "
      @send-order-to-customer="sendCartToCustomer($event)"
      @close="showCustomerModal = false"
      @search-seller="searchSeller($event)"
    />
  </div>
</template>

<script>
import bus from "@/utils/events/bus";
import ModalClienteInfo from "@/app/seller/components/ModalClienteInfo.vue";

export default {
  name: "SellerSendCartToCustomer",
  components: {
    ModalClienteInfo,
  },
  data() {
    return {
      showCardCustomer: true,
      sellers: [],
      showCustomerModal: false,
      isLoading: false,
    };
  },
  computed: {
    clienteId() {
      return this.$store.getters.clienteAtual;
    },
    dadosPedido() {
      return this.$store.getters.dadosPedido;
    },
    usuarioInfo() {
      return this.$store.getters.getUsuarioInfo;
    },
  },
  created() {},
  methods: {
    toggleCardHelp() {
      this.showCardCustomer = !this.showCardCustomer;
    },

    async sendCartToCustomer(dataCustomer) {
      this.isLoading = true;
      try {
        const url = `${process.env.VUE_APP_ECOMMERCE}${api.env.ENVIAR_CARRINHO_VENDEDOR}/${this.dadosPedido.pedidoId}/cliente/${this.clienteId}`;
        const { data } = await dpcAxios.connection().post(url, {
          permite_finalizar: dataCustomer.permite_finalizar,
        });
        if (data.error === 0) {
          bus.$emit("show-notification", ["success", "Sucesso", data.mensagem]);
          this.showCardCustomer = false;
          this.$store.dispatch("addItemCarrinhoAtual", "shouldCleanCart");
          this.$store.dispatch("setDadosPedido", {});
        } else if (data.error == 1 && data.code == 1) {
          bus.$emit("show-notification", [
            "error",
            "Função indisponível.",
            data.mensagem,
          ]);
          this.showCardCustomer = false;
        } else {
          bus.$emit("show-notification", ["error", "Erro", data.mensagem]);
        }
        this.showCustomerModal = false;
        this.isLoading = false;
      } catch (error) {
        bus.$emit("show-notification", ["error", "Erro", error]);
        ("");
        this.showCustomerModal = false;
        this.isLoading = false;
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/global.css";
@import "~@/assets/css/sass/bootstrap/variables";
.text-gray {
  color: $gray-dark;
}
.text-dpc {
  font-size: 15px;
  color: #545454;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  font-weight: 400;
  font-family: "Roboto", sans-serif;
}
.card-seller-list {
  max-height: 400px;
  overflow-y: auto;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
